<!--
  V 0.1.0 - 2025-07-29

-->
<template>
  <div>

    <!--
      <v-row class="text-center">
        <v-col lg="2" class="mx-auto">
          <v-btn id="buttonTop"
                 fab
                 dark
                 color="indigo"
                 :to="`/${previousPage}/${UnitID}/${VehicleReg}/${dayDate}`">
            <v-icon dark> mdi-arrow-left-circle </v-icon>
          </v-btn>
        </v-col>

        <v-col class="mb-0">
          <h1 class="text-h5 font-weight-bold mb-3">{{ VehicleReg }}</h1>

        </v-col>
      </v-row>
    -->

    <v-row align="start" justify="center" class="fill-width">
      <v-col cols="12">
        <!-- Dropdown for dataset selection -->
        <v-select v-model="selectedDataset"
                  :items="['All', ...rawChartData.datasets.map((d) => d.label)]"
                  label="Select Dataset"
                  outlined
                  dense
                  class="ma-1"></v-select>
      </v-col>
      <!--
        <v-col cols="12">
          <v-btn color="primary"
                 @click="selectedDataset = 'all'"
                 class="ma-1"
                 outlined>
            All
          </v-btn>

          <v-btn v-for="(dataset, index) in rawChartData.datasets"
                 :key="dataset.label"
                 :color="colorList[index % colorList.length]"
                 @click="selectedDataset = dataset.label"
                 class="ma-1"
                 outlined>
            {{ dataset.label }}
          </v-btn>

        </v-col>
  -->
    </v-row>

    <v-row align="start" justify="center" class="fill-width">
      <v-col cols="12">
        <LineChart :chart-data="filteredChartData" :options="chartOptions" />
      </v-col>
    </v-row>

    <v-row v-if="debugMode">

      <v-col>
        <v-col> ID: {{ VehicleID }} </v-col>

      </v-col>
    </v-row>

  </div>
</template>

<script>
import { Line } from 'vue-chartjs'
import axios from 'axios'
// import 'chartjs-plugin-zoom'

// const colors = ["red", "blue", "green", "purple", "orange", "teal", "cyan"];
const colors = [
  '#FF6384',
  '#36A2EB',
  '#FFCE56',
  '#4BC0C0',
  '#9966FF',
  '#FF9F40'
]

const ylabels = [
  'Engine Load', // o1
  'Coolant Temp', // o2
  'Speed (km/h)', // o3
  'RPM', // o4
  'Distance Traveled', // o5
  'DTC Count' // o6
]

const ylabels2 = [
  'o1', // o1
  'o2', // o2
  'o3', // o3
  'o4', // o4
  'o5', // o5
  'o6' // o6
]

const fieldMap = {}
for (let i = 0; i < ylabels.length; i++) {
  fieldMap[ylabels[i]] = ylabels2[i]
}

export default {
  name: 'TimeSeriesGraph',
  components: {
    LineChart: Line
  },
  data () {
    return {
      /// Debug paramters
      ///-------------------------------------------
      debugMode: this.$debug,

      /// Navigation paramts
      ///-------------------------------------------
      VehicleID: -1,
      dayDate: '',
      previousPage: '',
      UnitID: '',
      VehicleReg: '',

      /// Form parameters
      ///-------------------------------------------
      toggled: false,
      colorList: colors, // ["red", "blue", "green", "purple", "orange", "teal", "cyan"],

      /// Chart parameters
      ///-------------------------------------------
      selectedDataset: 'All',
      rawChartData: {
        labels: [],
        datasets: [
          {
            label: ylabels[0], // "o1",
            data: [],
            borderColor: colors[0], // "#FF6384",
            fill: false,
            yAxisID: 'y1'
          },
          {
            label: ylabels[1], // "o2",
            data: [],
            borderColor: colors[1], // "#36A2EB",
            fill: false,
            yAxisID: 'y2'
          },
          {
            label: ylabels[2], // "o3",
            data: [],
            borderColor: colors[2], // ,
            fill: false,
            yAxisID: 'y3'
          },
          {
            label: ylabels[3], // "o4",
            data: [],
            borderColor: colors[3], // "#4BC0C0",
            fill: false,
            yAxisID: 'y4'
          },
          {
            label: ylabels[4], // "o5",
            data: [],
            borderColor: colors[4], // "#9966FF",
            fill: false,
            yAxisID: 'y5'
          },
          {
            label: ylabels[5], // "o6",
            data: [],
            borderColor: colors[5], // "#FF9F40",
            fill: false,
            yAxisID: 'y6'
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'minute',
              displayFormats: {
                minute: 'yyyy-MM-dd HH:mm'
              }
            },
            title: {
              display: true,
              text: 'Time'
            }
          },
          y1: {
            type: 'linear',
            position: 'left',
            title: { display: true, text: ylabels[0] },
            grid: { drawOnChartArea: false }
          },
          y2: {
            type: 'linear',
            position: 'right',
            title: { display: true, text: ylabels[1] },
            grid: { drawOnChartArea: false }
          },
          y3: {
            type: 'linear',
            position: 'left',
            title: { display: true, text: ylabels[2] },
            grid: { drawOnChartArea: false }
          },
          y4: {
            type: 'linear',
            position: 'right',
            title: { display: true, text: ylabels[3] },
            grid: { drawOnChartArea: false }
          },
          y5: {
            type: 'linear',
            position: 'left',
            title: { display: true, text: ylabels[4] },
            grid: { drawOnChartArea: false }
          },
          y6: {
            type: 'linear',
            position: 'right',
            title: { display: true, text: ylabels[5] },
            grid: { drawOnChartArea: false }
          }
        },
        plugins: {

          /// zoom: {
          ///   zoom: {
          ///     wheel: { enabled: true }, // Enable zoom with mouse wheel
          ///     pinch: { enabled: true }, // Enable pinch zoom on touch devices
          ///     mode: 'xy' // Zoom on both x and y axes
          ///   },
          ///   pan: {
          ///     enabled: true,
          ///     mode: 'xy' // Pan on both x and y axes
          ///   },
          ///   limits: {
          ///     x: { min: 'original', max: 'original' }, // Respect original x-axis bounds
          ///     y1: { min: 'original', max: 'original' },
          ///     y2: { min: 'original', max: 'original' },
          ///     y3: { min: 'original', max: 'original' },
          ///     y4: { min: 'original', max: 'original' },
          ///     y5: { min: 'original', max: 'original' },
          ///     y6: { min: 'original', max: 'original' }
          ///   }
          /// }
        }
      }
    }
  },
  computed: {
    filteredChartData3 () {
      return {
        labels: this.rawChartData.labels,
        datasets: this.rawChartData.datasets.map((ds) => ({
          ...ds,
          borderWidth:
              ds.label === this.selectedDataset || this.selectedDataset === 'All'
                ? 3
                : 1,
          borderColor:
              ds.label === this.selectedDataset || this.selectedDataset === 'All'
                ? ds.borderColor
                : `${ds.borderColor}33` // Add transparency
        }))
      }
    },

    filteredChartData () {
      if (this.selectedDataset === 'All') {
        return {
          labels: this.rawChartData.labels,
          datasets: this.rawChartData.datasets
        }
      }
      const selected = this.rawChartData.datasets.find(
        (ds) => ds.label === this.selectedDataset
      )
      return {
        labels: this.rawChartData.labels,
        datasets: selected ? [selected] : []
      }
    },

    filteredChartData5 () {
      if (this.toggle) {
        return this.filteredChartData3
      } else {
        return this.filteredChartData4
      }
    },

    activeScales () {
      if (this.selectedDataset === 'All') {
        return {
          y1: this.chartOptions.scales.y1,
          y2: this.chartOptions.scales.y2,
          y3: this.chartOptions.scales.y3,
          y4: this.chartOptions.scales.y4,
          y5: this.chartOptions.scales.y5,
          y6: this.chartOptions.scales.y6
        }
      }
      const yAxisID = this.rawChartData.datasets.find(
        (ds) => ds.label === this.selectedDataset
      )?.yAxisID
      return yAxisID ? { [yAxisID]: this.chartOptions.scales[yAxisID] } : {}
    }
  },
  watch: {
    selectedDataset () {
      this.chartOptions.scales = {
        ...this.chartOptions.scales,
        ...this.activeScales
      }
    }
  },
  // mounted() {
  //   this.fetchData();
  // },

  mounted () {
    // debugger;
    let url = `${this.$baseUrl}/api/v2/trip-plot`
    url += `/${this.$route.params.Id}`
    /**
       *
      this.UnitID = this.$route.params.UnitID;
      this.VehicleReg = this.$route.params.VehicleReg;
      this.Driver = this.$route.params.Driver;
      this.UnitModelId = this.$route.params.UnitModelId;

       *
       */

    this.UnitID = this.$route.params.UnitID
    this.VehicleReg = this.$route.params.VehicleReg

    if (typeof this.$route.params.previousPage !== 'undefined') {
      this.previousPage = this.$route.params.previousPage
    }

    if (typeof this.$route.params.dayDate !== 'undefined') {
      this.dayDate = this.$route.params.dayDate
    }

    if (typeof this.$route.params.VehicleID !== 'undefined') {
      this.VehicleID = this.$route.params.VehicleID
    }

    if (this.$debug) {
      console.log(url)
    }

    this.$axios
      .get(url)
      .then((response) => {
        if (this.$debug) {
          console.log(response.data)
        }

        const points = JSON.parse(response.data.Points)
        this.processChartData(points)
      })
      .catch((e) => {
        console.log(e)
      })
  }, // mounted

  methods: {
    async fetchData () {
      try {
        const response = await axios.get(
          '/api/2a42ac01-dd44-4254-a53d-9f26c6bfa94a.json'
        )
        const points = JSON.parse(response.data.Points)
        this.processChartData(points)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },

    async fetchTrackingUnitData () {
      try {
        let url = this.$baseUrl
        url += '/api/v2/tracking-unit'
        url += `/${this.UnitID}`

        const response = await this.$axios.get(url)
        this.msg = `Vehicle data: ${JSON.stringify(response.data)}`

        this.InceptionDateString = response.data.InceptionDate
        console.error(this.msg)

        this.InceptionDate = new Date(this.InceptionDateString.split('+')[0])

        this.InceptionDateDisplay = this.formatDate(this.InceptionDate)

        this.diffInMs = this.currentDate - this.InceptionDate

        const months36InMs = 36 * 30.44 * 24 * 60 * 60 * 1000

        this.percentageElapsed = (this.diffInMs / months36InMs) * 100

        // const percentage = Math.min(Math.max(percentageElapsed, 0), 100);

        // Convert milliseconds to days
        const msPerDay = 24 * 60 * 60 * 1000

        this.daysElapsed = Math.round(this.diffInMs / msPerDay)

        this.monthsElapsedDisplay = this.monthsElapsed(
          this.InceptionDateString.split('+')[0]
        )

        Console.log()

        //
      } catch (error) {
        this.message = 'Error fetching vehicle data'
        console.error(error)
      }
    },

    processChartData (points) {
      // const labels = points.map((point) => new Date(point.timestamp));

      const labels = points.map(
        (point) => point.tm.split('T')[1].split('.')[0]
      )

      // const datasets = this.chartData.datasets.map((dataset) => ({
      //  ...dataset,
      //  data: points.map((point) => point[dataset.label]),
      // }));

      const datasets = this.rawChartData.datasets.map((dataset) => {
        /* const fieldMap = {
            "Engine Load": "o1",
            "Pressure (kPa)": "o2",
            "Humidity (%)": "o3",
            "Flow Rate (L/min)": "o4",
            "Voltage (V)": "o5",
            "Current (A)": "o6",
          }; */

        return {
          ...dataset,
          data: points.map((point) => point[fieldMap[dataset.label]])
        }
      })

      // const datasets = this.rawChartData.datasets.map((dataset) => ({
      //   ...dataset,
      //   data: points.map(
      //     (point) =>
      //       point[dataset.label.toLowerCase().replace(/[^a-z0-9]/g, "")]
      //   ),
      // }));

      this.rawChartData = {
        labels,
        datasets
      }
    },

    updateChart () {
      this.$nextTick(() => {
        this.$children[0].renderChart(
          this.filteredChartData,
          this.chartOptions
        )
      })
    }
  }
}
</script>

<style scoped></style>
